/** Rótulo público da mudança (somente UI; o id numérico na API/URL não muda). */

export function formatChangePublicId(id?: number | string | null): string {
  if (id === null || id === undefined || id === '') return '—';
  const numeric = typeof id === 'number' ? id : Number(String(id).trim());
  if (!Number.isFinite(numeric) || numeric <= 0) return '—';
  return `#GMUD${Math.trunc(numeric)}`;
}

/** Ex.: "Mudança #GMUD12" */
export function formatChangePublicLabel(id?: number | string | null): string {
  const code = formatChangePublicId(id);
  return code === '—' ? 'Mudança' : `Mudança ${code}`;
}

/** Remove prefixo GMUD/#GMUD para buscas digitadas pelo usuário. */
export function parseChangePublicIdQuery(raw: string): string {
  const text = (raw || '').trim();
  if (!text) return text;
  const upper = text.toUpperCase();
  if (upper.startsWith('#GMUD')) return text.slice(5).trim();
  if (upper.startsWith('GMUD')) return text.slice(4).trim();
  return text;
}
